<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <!-- <v-btn
            flat
            :color="$store.state.global.pages.contractor.color"
            @click="openRequest"
          >Create Request</v-btn>-->
          <v-btn
            color="teal"
            flat
            router
            :icon="!$vuetify.breakpoint.smAndUp"
            :to="{name: 'vehicleType'}"
          >
            <v-icon
              :left="$vuetify.breakpoint.smAndUp"
            >{{$store.state.global.pages.vehicleType.icon}}</v-icon>
            {{$vuetify.breakpoint.smAndUp ? 'Modify Types...' : ''}}
          </v-btn>
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 lg3>
          <div class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.contractor.icon"
              :color="$store.state.global.pages.contractor.color"
              label="Sub-contractor"
              :items="contractors"
              v-model="contractor"
              item-text="name"
              :loading="loadingContractors"
              :clearable="true"
              item-value="id"
            ></v-autocomplete>
            <div class="ml-3" v-if="!!contractor">
              <v-switch
                :color="$store.state.global.pages.contractor.color"
                label="Details"
                v-model="showDetails"
              ></v-switch>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Type"
            :items="['Active', 'Inactive', 'Request']"
            v-model="selectedRecordType"
          ></v-select>
        </v-flex>

        <!--CONTROL INFO DISPLAY -->
        <control-info-display :data="contractorObj" route="contractor" v-model="showDetails"></control-info-display>
      </layout-no-padding>

      <!-- <v-layout class="justify-end">
        <x-flex xs12>
          <v-btn flat color="primary" @click="openRequest">Request</v-btn>
        </x-flex>
      </v-layout>-->

      <v-dialog
        v-model="addVehicleDialog"
        max-width="500px"
        @keydown.esc="addVehicleDialog = false"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-vehicle" slot="activator">
          <v-icon dark>{{ isRequest ? 'post_add' : 'add' }}</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-vehicle @close="addVehicleDialog = false" :isRequest="isRequest"></add-vehicle>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
    <!-- <vehicle-type-control></vehicle-type-control> -->
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import VehicleValidation from '@/services/validation/vehicleValidation'
import AddVehicle from '@/components/vehicles/addVehicle'
import VehicleTypeControl from '@/components/vehicleTypes/vehicleTypeControl'
import ControlInfoDisplay from '@/components/ui/controlInfoDisplay'
import RouteProps from '@/services/mixins/routeProps'

//GET RECORDS
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
export default {
  mixins: [
    VehicleValidation,
    RouteProps,
    getVehicles,
    getContractors,
    getProjects,
  ],
  data() {
    return {
      includeInactive: true,
      addVehicleDialog: false,
      sortFactors: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'name',
          text: 'Name',
        },
        {
          value: 'details',
          text: 'Details',
        },
        {
          value: 'contractor.name',
          text: 'Contractor',
        },
        {
          value: 'updatedAt',
          text: 'Updated At',
        },
      ],
    }
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    },
    sortVehicles(path1, path2) {
      return this.vehicles.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1
        } else {
          return 1
        }
      })
    },
  },
  computed: {
    contractorObj() {
      if (!!this.contractor) {
        return this.getObjByPrimaryId(this.contractor, this.contractors)
      } else {
        return null
      }
    },
    isRequest() {
      return this.$store.state.user.userAuthClass.name !== 'Administrator'
    },
    sortBy: Store.getSet({ store: 'vehicles', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'vehicles', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'vehicles', prop: 'listView' }),
    contractor: Store.getSet({ store: 'vehicles', prop: 'contractor' }),
    showDetails: Store.getSet({ store: 'vehicles', prop: 'showDetails' }),
    showInactive: Store.getSet({ store: 'vehicles', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'vehicles',
      prop: 'selectedRecordType',
    }),
  },
  components: {
    AddVehicle,
    ControlInfoDisplay,
    VehicleTypeControl,
  },
  watch: {
    contractorObj(val) {
      if (!!val) {
        this.showDetails = true
      } else {
        this.showDetails = false
      }
    },
  },
}
</script>

<style scoped>
.overlap-fab-vehicle {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
